// docs/117 TT3: commissioned one-square creatures. The sim names them by appearance numbers past the
// Oryx creature frames (fk-sim `ART_TENTACLE_1` ..), as it names the huge bodies (hugeArt.ts); the
// client draws each from its own 24 px sprite (tools/creature-art.py → public/assets/creatures/),
// exactly as an Oryx frame is drawn: one art pixel to one world pixel, standing on its square's
// bottom edge, facing east as drawn. Nothing about them is huge: no aura, no reveal card.

/** Which kind of commissioned creature it is: each kind has its own board effects. */
export type CreatureKind = 'tentacle';

/** What it comes up through (the Thing Below's arms: its pool, or the desert sand). */
export type CreatureGround = 'water' | 'sand';

export interface CreatureArt {
  /** The Phaser texture key (loaded in Boot). */
  key: string;
  url: string;
  kind: CreatureKind;
  ground: CreatureGround;
  /** What the HUD calls it. */
  name: string;
}

const tentacle = (n: 1 | 2 | 3, ground: CreatureGround): CreatureArt => {
  const file = ground === 'sand' ? `sand-tentacle-${n}` : `tentacle-${n}`;
  return { key: `creature-${file}`, url: `/assets/creatures/${file}.png`, kind: 'tentacle', ground, name: ground === 'sand' ? 'Sand tentacle' : 'Tentacle' };
};

/** fk-sim `ART_TENTACLE_1..3` (913–915) and `ART_SAND_TENTACLE_1..3` (916–918). */
export const CREATURE_ART: Readonly<Record<number, CreatureArt>> = {
  913: tentacle(1, 'water'),
  914: tentacle(2, 'water'),
  915: tentacle(3, 'water'),
  916: tentacle(1, 'sand'),
  917: tentacle(2, 'sand'),
  918: tentacle(3, 'sand'),
};

/** The commissioned one-square sprite for an appearance, if it has one. */
export function creatureArt(appearance: number | undefined): CreatureArt | undefined {
  return appearance === undefined ? undefined : CREATURE_ART[appearance];
}

/** The commissioned one-square sprite drawn under a texture key, if it is one. */
export function creatureArtByKey(key: string): CreatureArt | undefined {
  return Object.values(CREATURE_ART).find((a) => a.key === key);
}
